export default "__VITE_ASSET__DUfIi$_F__"